// src/pages/menu/ContinentalTablesAndOrdersDashboard.jsx
import React from 'react';
import LocationTablesAndOrdersDashboard from '../TablesAndOrdersDashboard';

const ContinentalTablesAndOrdersDashboard = () => {
  return <LocationTablesAndOrdersDashboard locationKey="continental" />;
};

export default ContinentalTablesAndOrdersDashboard;